export default __webpack_public_path__ + "static/media/baseline-location_off-24px.b8f86209.svg";